import React from 'react';

/**
 * Card-style container with optional header (title / sub / actions).
 * Mirrors the prototype's `.panel` / `.panel-head` / `.panel-title` / `.panel-sub`.
 *
 * <Panel title="Commission" sub="Last 12 months" actions={<button className="btn">Export</button>}>
 *   ...children
 * </Panel>
 */
const Panel = ({title, sub, actions, children, className = '', headClassName = '', ...rest}) => {
    const cn = ['panel', className].filter(Boolean).join(' ');
    const headCn = ['panel-head', headClassName].filter(Boolean).join(' ');
    const hasHead = Boolean(title || sub || actions);
    return (
        <div className={cn} {...rest}>
            {hasHead && (
                <div className={headCn}>
                    <div>
                        {title && <div className="panel-title">{title}</div>}
                        {sub && <div className="panel-sub">{sub}</div>}
                    </div>
                    {actions}
                </div>
            )}
            {children}
        </div>
    );
};

export default Panel;
